import { Container, Grid } from '@mui/material';
import { useContext, useLayoutEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import IssueReportInfo from '../../issueReportDetails/IssueReportInfo';
import { makePermittedIssueReportListSelector } from '../../../selector/issueReportsSelector';
import { HeaderRightButtonContext } from '../../../layout/MainLayout';
import IssueReportsCommands from '../../../action/issueReportsCommands';
import { paths } from '../../../routes';
import IssueReportUnavailable from '../../issueReportDetails/IssueReportUnavailable';
import IssueReportComments from '../../issueReportDetails/IssueReportComments';

const ApartmentRentalIssueReportDetailsPage = () => {
    const dispatch = useDispatch();
    const headerRightButton = useContext(HeaderRightButtonContext);
    const params = useParams<{ issueReportId: string }>();
    const issueReportId = params.issueReportId || '';

    const permittedIssueReports = useSelector(makePermittedIssueReportListSelector());

    const issueReport = permittedIssueReports.find((issueReport) => issueReport.id === issueReportId);

    // Layout effect: the refetch below must mark the list as loading before
    // the first paint, or a list already 'loaded' without this report flashes
    // "no longer exists" for a frame.
    useLayoutEffect(() => {
        headerRightButton.setButtonState({ isCancelButton: true, previousRoute: paths.rentalIssueReports });

        // On a hard refresh of the detail URL, the list isn't loaded yet.
        // We can't rely on the per-id fetch here because its saga writes to a
        // different state slice than the page reads from — so the dropdown,
        // booking lookup, etc. all break. Re-use the list fetcher that the
        // index page uses; that populates `issueReports` which this page's
        // selector reads.
        // Archived reports included: a direct link (e.g. a goodwill code's
        // "View report") may point at an archived one, and leaving it out
        // would report an existing report as gone.
        if (!issueReport) {
            dispatch(IssueReportsCommands.fetchIssueReports({ includeArchived: true }));
        }

        // Disarm the X on unmount — without this, navigating back (e.g.
        // to the all-tenant view) leaves a stale cancel button that still
        // points at this tenant's issue report list.
        return () => {
            headerRightButton.setButtonState({ isCancelButton: false, previousRoute: '' });
        };
    }, [params.issueReportId]);

    if (!issueReport) {
        return <IssueReportUnavailable />;
    }

    return (
        <Container maxWidth={false} className={'px-0 sm:px-4'}>
        
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12} md={6}>
                    <IssueReportInfo issueReport={issueReport!} />
                </Grid>
                <Grid item={true} xs={12} md={6}>
                    <IssueReportComments issueReport={issueReport!} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ApartmentRentalIssueReportDetailsPage;
